// "Sent" pips: how many of my orders are on the wire but not yet in an applied
// frame. Lockstep delays every order by a tick or two, so without this a click
// reads as dropped.
//
// A frame carries my seat's whole batch for that tick, so applying it settles
// that many orders. An order the server rejects never comes back in a frame,
// so a pip also expires on its own rather than sticking forever.

export const PIP_EXPIRY_MS = 5000;

export class PendingIntents {
  private sentAt: number[] = [];

  /** Record one order sent now. */
  sent(now = Date.now()): void {
    this.sentAt.push(now);
  }

  /** An applied frame carried `n` of my orders. */
  landed(n: number): void {
    if (n > 0) this.sentAt.splice(0, n);
  }

  /** Orders still in flight (expired ones are dropped). */
  count(now = Date.now()): number {
    this.sentAt = this.sentAt.filter((t) => now - t < PIP_EXPIRY_MS);
    return this.sentAt.length;
  }
}

/** Banner text for the other seats that are disconnected, or null. */
export function absentMessage(names: readonly string[]): string | null {
  if (names.length === 0) return null;
  const who =
    names.length === 1 ? names[0] : `${names.slice(0, -1).join(', ')} and ${names.at(-1)}`;
  return `${who} ${names.length === 1 ? 'has' : 'have'} disconnected — the game continues and they can rejoin.`;
}
